import {
  post_request
} from "../axiosFun"

//列表查询
export const get_station_list = (params) => {
  params = {
    row: {
      map_id: window.localStorage.getItem("map_id"),
      line_id: window.localStorage.getItem("line_id"),
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/station/get_stations", params)
};
//获取单条站点信息
export const get_station_one = (params) => {
  params = {
    row: {
      line_id:window.localStorage.getItem("line_id"),
      station_id: params
    }
  }
  return post_request("/web/station/get_one", params)
};
//修改站点信息
export const get_station_edit = (params) => {
  params = {
    row: {
      id: params.id,
      name: params.name,
      number: params.number,
      head: params.head,
      head_phone: params.head_phone,
      location: params.location,
      line_id: params.line_id || '',
      remarks: params.remarks || ''
    }
  }
  return post_request("/web/site/update", params)
};
//修改状态
export const get_station_status = (params, status) => {
  params = {
    row: {
      id: params,
      status: status
    }
  }
  return post_request("/web/site/update_status", params)
};
//站点地图
export const get_line_detail = (params) => {
  params = {
      row:{
        map_id: window.localStorage.getItem("map_id"),
        line_id: window.localStorage.getItem("line_id"),

      }
  }
  return post_request("/web/line/line_detail",params)
};



// WEBPACK FOOTER //
// ./src/api/station/station.js